<template>
  <div class="empty-state">
    <img :src="require('@/assets/img/img-empty-state-rides.svg')" alt="" class="empty-state__img">
    <span v-html="$t(`${namespace}.form.emptyState`)" class="empty-state__text" />
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  data () {
    return {
      namespace: 'Views.NewWebCallPage'
    }
  }
}
</script>

<style lang="scss" scoped>
.empty-state {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  text-align: center;
}

.empty-state__img {
  margin-bottom: 24px;
  max-width: 100px;
}

.empty-state__text {

  a {
    color: $accent;
  }
}
</style>
